import { Breadcrumb,Button,Form,Modal,Input,InputNumber,Spin,Popconfirm,message,Space, Select, Switch, Radio, Tag, Descriptions } from "antd";
import Header from "../../components/dashboard/header";
import {DashboardOutlined,PlusSquareOutlined,EditOutlined,DeleteOutlined,EyeOutlined} from "@ant-design/icons";
import {BsGift} from "react-icons/bs";
import {useState,useRef,useContext,useEffect} from "react"
import DataTable from "../../components/common/table";
import { Link, useNavigate } from "react-router-dom";
import RefreshContext from "../../context/refreshContext";
import { extractValueFromInputRef } from "../../helpers/dom";
import { useCreateBenefit, useDeleteBenefit, useGetAllBenefitScopes, useGetAllBenefits, useUpdateBenefit, useGetAllLevels, useGetAllSteps } from "../../hooks/payrollData/payrollDataQuery";
import { useGetAllStaffCategories } from "../../hooks/staffcategory/staffCategoryQuery";
import { usePVTypes } from "../../hooks/voucherTypes/voucherTypeQuery";
import { hasPayrollAccess } from "../../helpers/roles";
import { userStore } from "../../store/userStore";

const {Option} = Select;

const COMPUTATION_TYPES = {
    FIXED: 'FIXED',
    PERCENTAGE: 'PERCENTAGE'
};



const benefitTableColumns =[
    {
        title:"S/N",
        key:"s/n",
        render:(_,__,idx)=>idx+1
    },
    {
        title:"Title",
        key:"title",
        dataIndex:"benefitName"
    },
    {
        title:"Value",
        key:"value",
        dataIndex:"benefitValue"
    },
    {
        title:"Computation Type",
        key:"computationType",
        dataIndex:"computationType"
    },
    {
        title:"Levels",
        key:"levels",
        dataIndex:"levels",
        render: (_, record) => record.levels?.map(l => l.title).join(", ") || "-"
    },
    {
        title:"Steps",
        key:"steps",
        dataIndex:"steps",
        render: (_, record) => record.steps?.map(s => s.title).join(", ") || "-"
    },
    {
        title:"Staff Categories",
        key:"staffCategories",
        dataIndex:"staffCategories",
        render: (_, record) => record.staffCategories?.map(sc => sc.title).join(", ") || "-"
    },
    {
        title:"Salary Structure",
        key:"salaryStructure",
        dataIndex:"salaryStructure",
        render: (_, record) => record.salaryStructure?.title || "-"
    },
    {
        title:"Applies To All",
        key:"appliesToAllUsers",
        dataIndex:"appliesToAllUsers",
        render: (_, record) => record.appliesToAllUsers ? "Yes" : "No"
    },
    {
        title:"Actions",
        key:"actions",
        render:(_,benefit)=>(<BenefitEdit benefit={benefit}/>)
    }
]



function BenefitEdit({benefit}){
    const [isEditOpen,setIsEditOpen] = useState(false);
    const [isViewOpen,setIsViewOpen] = useState(false);
    const [scope,setScope] = useState(benefit?.benefitScope);
    const [levels, setLevels] = useState(benefit?.levels?.map(l => l.id) || []);
    const [steps, setSteps] = useState(benefit?.steps?.map(s => s.id) || []);
    const [staffCategories, setStaffCategories] = useState(benefit?.staffCategories?.map(sc => sc.id) || []);
    const [salaryStructure, setSalaryStructure] = useState(benefit?.salaryStructure);
    const [appliesToAllUsers, setAppliesToAllUsers] = useState(benefit?.appliesToAllUsers || false);
    const [computationType, setComputationType] = useState(benefit?.computationType || COMPUTATION_TYPES.FIXED);

    const {flag,setFlag} = useContext(RefreshContext);
    const {scopes} = useGetAllBenefitScopes();
    const {levels: allLevels} = useGetAllLevels();
    const {steps: allSteps} = useGetAllSteps();
    const {staffCategories: allStaffCategories} = useGetAllStaffCategories();
    const {structures} = usePVTypes();

    const deleteBenefit = useDeleteBenefit();
    const updateBenefit = useUpdateBenefit();

    const titleRef = useRef(null);
    const valueRef = useRef(null);


    const confirmDeleteBenefit = async ()=>{
        await deleteBenefit(benefit.id);
        setFlag(!flag);
        message.success("Benefit deleted Successfully");
    }


    const handleSubmit = async ()=>{
        const payload = {
            benefitName:extractValueFromInputRef(titleRef),
            benefitValue:parseFloat(valueRef.current.value) || 0,
            benefitScope:scope,
            computationType: computationType,
            levels: appliesToAllUsers ? [] : levels,
            steps: appliesToAllUsers ? [] : steps,
            staffCategories: appliesToAllUsers ? [] : staffCategories,
            salaryStructure: appliesToAllUsers ? null : (typeof salaryStructure === 'object' && salaryStructure !== null ? salaryStructure.id : salaryStructure),
            appliesToAllUsers: appliesToAllUsers
        }
        await updateBenefit(benefit.id,payload);
        message.success("Benefit updated successfully");
        setFlag(!flag);
        setIsEditOpen(false);
    }


    return (
        <>
              <Space size="small" wrap>
                <Button type="default" onClick={()=>setIsViewOpen(true)}>
                    <EyeOutlined/>
                    View
                </Button>
                <Button type="primary" onClick={()=>setIsEditOpen(true)}>
                    <EditOutlined/>
                    Edit
                </Button>
                <Popconfirm
                     title="Delete this benefit"
                     description="Are you sure to delete this ?"
                     onConfirm={confirmDeleteBenefit}
                    onCancel={()=>null}
                    okText="Yes"
                    cancelText="No"
                     >
                    <Button type="primary" danger>
                        <DeleteOutlined />
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
            
            {/* View Modal */}
            <Modal 
                title="View Benefit Details" 
                open={isViewOpen} 
                footer={[
                    <Button key="close" onClick={() => setIsViewOpen(false)}>
                        Close
                    </Button>
                ]}
                onCancel={() => setIsViewOpen(false)}
                width={600}
            >
                <Descriptions bordered column={2} size="small">
                    <Descriptions.Item label="Benefit Name" span={2}>
                        <strong>{benefit?.benefitName}</strong>
                    </Descriptions.Item>
                    <Descriptions.Item label="Computation Type">
                        <Tag color={benefit?.computationType === 'FIXED' ? "green" : "cyan"}>
                            {benefit?.computationType}
                        </Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Value">
                        {benefit?.computationType === 'PERCENTAGE' 
                            ? `${benefit?.benefitValue}%` 
                            : `₦${benefit?.benefitValue?.toLocaleString() || 0}`}
                    </Descriptions.Item>
                    <Descriptions.Item label="Benefit Scope">
                        {benefit?.benefitScope || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Applies To All Users">
                        <Tag color={benefit?.appliesToAllUsers ? "green" : "orange"}>
                            {benefit?.appliesToAllUsers ? "Yes" : "No"}
                        </Tag>
                    </Descriptions.Item>
                    {!benefit?.appliesToAllUsers && (
                        <>
                            <Descriptions.Item label="Levels">
                                {benefit?.levels?.map(l => l.title).join(", ") || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Steps">
                                {benefit?.steps?.map(s => s.title).join(", ") || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Staff Categories">
                                {benefit?.staffCategories?.map(sc => sc.title).join(", ") || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Salary Structure">
                                {benefit?.salaryStructure?.title || "-"}
                            </Descriptions.Item>
                        </>
                    )}
                </Descriptions>
            </Modal>
            
            {/* Edit Modal */}
            <Modal title="Update Benefit" open={isEditOpen} footer={null} onCancel={()=>setIsEditOpen(false)}>
            <div style={{marginTop:"3em",maxHeight:"70vh",overflowY:"scroll",paddingLeft:"1em",paddingRight:"1em"}}>
                    <Form wrapperCol={{
                                span: 24,
                              }}
                              initialValues={{...benefit}}>

                                <Form.Item name="benefitName"  rules={[
                                    {
                                      required: true,
                                      message:'Please Benenfit Name'
                                    },
                                  ]}>
                                    <Input
                                    ref={titleRef}
                                    placeholder="Enter Benefit Name"/>
                                </Form.Item>
                                <Form.Item name="benefitValue">
                                    <InputNumber style={{width:"100%"}} placeholder="Enter Benefit Amount" ref={valueRef}/>
                                </Form.Item>
                                <Form.Item name="computationType" label="Computation Type">
                                    <Radio.Group onChange={(e) => setComputationType(e.target.value)} value={computationType}>
                                        <Radio value={COMPUTATION_TYPES.FIXED}>Fixed</Radio>
                                        <Radio value={COMPUTATION_TYPES.PERCENTAGE}>Percentage</Radio>
                                    </Radio.Group>
                                </Form.Item>
                                <Form.Item name="levels">
                                    <Select mode="multiple" allowClear placeholder="Select Levels" onChange={(e)=>setLevels(e)} value={levels}>
                                        {
                                            allLevels?.map((l,idx)=>(
                                                <Option value={l.id} key={idx}>{l.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item name="steps">
                                    <Select mode="multiple" allowClear placeholder="Select Steps" onChange={(e)=>setSteps(e)} value={steps}>
                                        {
                                            allSteps?.map((s,idx)=>(
                                                <Option value={s.id} key={idx}>{s.title} - {s?.level?.title} - {s?.level?.salaryStructure?.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item name="staffCategories">
                                    <Select mode="multiple" allowClear placeholder="Select Staff Categories" onChange={(e)=>setStaffCategories(e)} value={staffCategories}>
                                        {
                                            allStaffCategories?.map((sc,idx)=>(
                                                <Option value={sc.id} key={idx}>{sc.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item name="salaryStructure">
                                    <Select allowClear placeholder="Select Salary Structure" onChange={(e)=>setSalaryStructure(e)}>
                                        {
                                            structures.map((s,idx)=>(
                                                <Option value={s.id} key={idx}>{s.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item name="appliesToAllUsers" valuePropName="checked">
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <span style={{marginRight: "10px"}}>Applies To All Users:</span>
                                        <Switch onChange={(e)=>setAppliesToAllUsers(e)} />
                                    </div>
                                </Form.Item>
                                <Form.Item wrapperCol={{
                        span:8,
                        offset:20
                      }}>
                        <Button type="primary" onClick={handleSubmit}>
                            Update
                        </Button>
                    </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}



export default function Benefit(){
    const navigate = useNavigate();
    const user = userStore(state => state.user);

    const [isOpen,setIsOpen] = useState(false);
    const [scope,setScope] = useState("");
    const [levels, setLevels] = useState([]);
    const [steps, setSteps] = useState([]);
    const [staffCategories, setStaffCategories] = useState([]);
    const [salaryStructure, setSalaryStructure] = useState(null);
    const [appliesToAllUsers, setAppliesToAllUsers] = useState(false);
    const [computationType, setComputationType] = useState(COMPUTATION_TYPES.FIXED);

    // Check access permissions
    useEffect(() => {
        if (user && !hasPayrollAccess(user.roles)) {
            message.error('You do not have permission to access this page');
            navigate('/dashboard');
        }
    }, [user, navigate]);


    const titleRef = useRef(null);
    const valueRef = useRef(null);

    const showCreateModal = ()=>setIsOpen(true);
    const hideCreateModal = ()=>setIsOpen(false);

    const {flag,setFlag} = useContext(RefreshContext);

    const createBenefit = useCreateBenefit();
    const {scopes} = useGetAllBenefitScopes();
    const {loading,benefits} = useGetAllBenefits(flag);
    const {levels: allLevels} = useGetAllLevels();
    const {steps: allSteps} = useGetAllSteps();
    const {staffCategories: allStaffCategories} = useGetAllStaffCategories();
    const {structures} = usePVTypes();


    const handleSubmit = async ()=>{
        const payload = {
            benefitName:extractValueFromInputRef(titleRef),
            benefitValue:parseFloat(valueRef.current.value) || 0,
            benefitScope:scope,
            computationType: computationType,
            levels: appliesToAllUsers ? [] : levels,
            steps: appliesToAllUsers ? [] : steps,
            staffCategories: appliesToAllUsers ? [] : staffCategories,
            salaryStructure: appliesToAllUsers ? null : (typeof salaryStructure === 'object' && salaryStructure !== null ? salaryStructure.id : salaryStructure),
            appliesToAllUsers: appliesToAllUsers
        }
        await createBenefit(payload);
        setFlag(!flag);
        message.success("Benefit created successfully");
        setIsOpen(false);
    }


    return (
        <>
        <div className="main-container">
            <Header/>
            <div className="main-body">
                <div className="info-bar">
                <Breadcrumb>
                            <Breadcrumb.Item>
                            <DashboardOutlined className="dashboard-icon"/>
                            <Link to={"/dashboard"}>
                                Dashboard
                            </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <BsGift/>
                                <Link to="/dashboard/benefit">
                                    Benefit
                                </Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div style={{display:'flex',gap:'1em'}}>
                        <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={showCreateModal}>
                                <PlusSquareOutlined/>
                                Add Benefit
                            </Button>
                        </div>
                </div>
                <div className="table-section">
                        <Spin spinning={loading}>
                            <DataTable cols={benefitTableColumns} data={benefits}/>
                        </Spin>
                    </div>
            </div>
        </div>
        <Modal title="Add Benefit" open={isOpen} footer={null} onCancel={hideCreateModal}>
            <div style={{marginTop:"3em",maxHeight:"70vh",overflowY:"scroll",paddingLeft:"1em",paddingRight:"1em"}}>
                    <Form  wrapperCol={{
                                span: 24,
                              }}>

                                <Form.Item>
                                    <Input
                                    ref={titleRef}
                                    placeholder="Enter Title" rules={[
                                    {
                                      required: true,
                                      message:'Please input title'
                                    },
                                  ]}/>
                                </Form.Item>
                                <Form.Item>
                                    <InputNumber style={{width:"100%"}} placeholder="Enter benefit amount" ref={valueRef}/>
                                </Form.Item>
                                <Form.Item label="Computation Type">
                                    <Radio.Group onChange={(e) => setComputationType(e.target.value)} value={computationType}>
                                        <Radio value={COMPUTATION_TYPES.FIXED}>Fixed</Radio>
                                        <Radio value={COMPUTATION_TYPES.PERCENTAGE}>Percentage</Radio>
                                    </Radio.Group>
                                </Form.Item>
                                <Form.Item>
                                    <Select mode="multiple" allowClear placeholder="Select Levels" onChange={(e)=>setLevels(e)}>
                                        {
                                            allLevels?.map((l,idx)=>(
                                                <Option value={l.id} key={idx}>{l.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item>
                                    <Select mode="multiple" allowClear placeholder="Select Steps" onChange={(e)=>setSteps(e)}>
                                        {
                                            allSteps?.map((s,idx)=>(
                                                <Option value={s.id} key={idx}>{s.title} - {s?.level?.title} - {s?.level?.salaryStructure?.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item>
                                    <Select mode="multiple" allowClear placeholder="Select Staff Categories" onChange={(e)=>setStaffCategories(e)}>
                                        {
                                            allStaffCategories?.map((sc,idx)=>(
                                                <Option value={sc.id} key={idx}>{sc.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item>
                                    <Select allowClear placeholder="Select Salary Structure" onChange={(e)=>setSalaryStructure(e)}>
                                        {
                                            structures.map((s,idx)=>(
                                                <Option value={s.id} key={idx}>{s.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <span style={{marginRight: "10px"}}>Applies To All Users:</span>
                                        <Switch onChange={(e)=>setAppliesToAllUsers(e)} />
                                    </div>
                                </Form.Item>
                                <Form.Item wrapperCol={{
                        span:8,
                        offset:20
                      }}>
                        <Button type="primary" onClick={handleSubmit}>
                            Create
                        </Button>
                    </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}
